import {
  ORDER_ITEM_ADD,
  ORDER_DELETE,
  ORDER_ITEMNOTE_ADD,
  ORDER_DISCOUNT_ADD,
  ORDER_LOCATION_ADD,
  ORDER_NOTE_ADD,
  ORDER_NAME_ADD,
  ORDER_MODIFIER_ADD,
  ORDER_RESET,
  ORDER_CALCULATE_TOTAL,
} from '../actions/index';
import _ from 'lodash';

let initialState = {
  "subtotal": 0,
  "hst": 0,
  "grandtotal": 0,
  "discount": 0,
  "order_note": '',
  "order_name": '',
  "order_location": '',
  "items": {},
  "payments": {},
  "change": 0,
  "lastItemID": 0,
};

export default function(state = initialState, action) {
  switch(action.type) {
    case ORDER_CALCULATE_TOTAL:
      return {
        ...state,
        "subtotal": action.subtotal,
        "hst": action.hst,
        "grandtotal": action.grandtotal,
      }
    case ORDER_ITEM_ADD:
      return {
        ...state,
        "items": {
          ...state.items,
          [action.id]: {
            order_items_id: action.id,
            id:action.item.id,
            cat_id: action.item.cat_id,
            name:action.item.name,
            price:action.item.price,
            note:action.item.note,
            modifiers: {},
            has_modifiers: action.item.has_modifiers,
          }
        },
        "lastItemID": action.id,
      }
    case ORDER_MODIFIER_ADD:
      let itemWithMod = state.items[action.id];
      itemWithMod.modifiers = action.modifiers;

      return {
        ...state,
        "items": {
          ...state.items,
          [action.id]: itemWithMod
        },
      }
    case ORDER_DELETE:
      let items = _.omit(state.items, [action.id]);

      return {
        ...state,
        "items": items,
      }
    case ORDER_ITEMNOTE_ADD:
      let item = state.items[action.id];
      item.note = action.note;

      return {
        ...state,
        "items": {
          ...state.items,
          [action.id]: item
        },
      }
    case ORDER_DISCOUNT_ADD:
      return {
        ...state,
        "discount": action.discount,
      }
    case ORDER_LOCATION_ADD:
      return {
        ...state,
        "order_location": action.location,
      }
    case ORDER_NOTE_ADD:
      return {
        ...state,
        "order_note": action.note,
      }
    case ORDER_NAME_ADD:
      return {
        ...state,
        "order_name": action.order_name,
      }
    case ORDER_RESET:
      return {
        "subtotal": 0,
        "hst": 0,
        "grandtotal": 0,
        "discount": 0,
        "order_note": '',
        "order_name": '',
        "order_location": '',
        "items": {},
        "payments": {},
        "change": 0,
        "lastItemID": 0,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_current_order.js